import React from 'react';
import DocViewer from '@cyntler/react-doc-viewer';
import { useSearchParams } from 'react-router';
import { GenerateIcs201Button } from './GenerateIcs201Button';
import { SharedIcon } from 'components/SharedIcon/SharedIcon';
import { CollapsibleCard } from 'components/DesignSystems/Collapse/CollapsibleCard';
import { getIncidentCardTitle } from '../planningView/USCGPage';
import { useActualIncidentId } from '../hooks/commonHooks';
import { useIcs201Op0 } from 'hooks/incident/useIcs201Op0';

/** 'Incident briefing' tab for 'Initial response' view (OP 0) */
const InitialResponseBriefing: React.FC = () => {
  const [searchParams] = useSearchParams();
  const phase = searchParams.get('phase');
  const mode = searchParams.get('mode');
  const sectionKey = `${phase}-${mode}-incident-briefing`;
  const incidentId = useActualIncidentId();
  const { displayDocuments } = useIcs201Op0(incidentId);

  return (
    <CollapsibleCard
      sectionKey={sectionKey}
      className="planning-widget w-100"
      contentClassName="content mt-2"
      defaultCollapsed={false}
      headerLeft={
        <h3 className="m-0">
          <SharedIcon
            iconName="description"
            classes="me-2"
            size="md"
            color="primary"
          />
          {getIncidentCardTitle('initialResponse')}
        </h3>
      }
      headerRight={<GenerateIcs201Button />}
    >
      {displayDocuments ? (
        <DocViewer documents={displayDocuments} />
      ) : (
        <div className="section-main d-flex flex-column align-items-center">
          <div className="d-flex justify-content-center">
            <SharedIcon iconName="description" classes="me-2" size="lg" />
          </div>
          <div>
            <div className="fs-5 mb-2">
              {getIncidentCardTitle('initialResponse')}
            </div>
            <div className="mb-2">
              You have not generated an ICS-201 yet. Once you have, it will be
              displayed here.
            </div>
          </div>
        </div>
      )}
    </CollapsibleCard>
  );
};

export default InitialResponseBriefing;
